import {LANG} from '../app/shared/modules/translate/translate.model';

export const environment = {
    production: true,
    defaultLanguage: LANG.DE,
      apiUrl: 'https://api.workbase.dev/v1',
    indexableInSearchEngines: false,
};
